import React from 'react';

export default function Price({
  priceState,
}: {
  priceState: {
    price: string,
    promotionalPrice: string,
    onPromotion: boolean,
  }
}) {
  return (
    <>
      {priceState.onPromotion && (
        <span className="block leading-normal text-light-grey-2 text-xl lg:text-xl-secondary">
          <s>{Craft.formatCurrency(priceState.price)}</s>
        </span>
      )}
      <span className="block leading-tight text-2xl lg:text-2xl-secondary">{priceState.onPromotion ? Craft.formatCurrency(priceState.promotionalPrice) : Craft.formatCurrency(priceState.price)}</span>
    </>
  );
}
